function toggleHiddenClass(elHeader, toggle) {
  const $elSection = $(elHeader).next('.hpe-disclosure__section');

  let hidden = $elSection.attr('aria-hidden') !== 'true';
  if (toggle) {
    hidden = !hidden;
  }

  if (hidden) {
    $elSection.attr('aria-hidden', false);
  } else {
    $elSection.attr('aria-hidden', true);
  }
}

$(document).ready(() => {
  $('.hpe-disclosure__button:not([data-disclosure])')
    .click(function () {
      toggleHiddenClass(this, true);
    })
    .each((index, el) => toggleHiddenClass(el));

  $('.hpe-filter__button').click(function () {
    $(this)
      .siblings('.hpe-filter__list')
      .toggleClass('hpe-filter--expanded');
  });
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/hpe-filter.js